import { render, staticRenderFns } from "./SettingsClientModal.vue?vue&type=template&id=255609db&scoped=true&"
import script from "./SettingsClientModal.vue?vue&type=script&lang=js&"
export * from "./SettingsClientModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsClientModal.vue?vue&type=style&index=0&id=255609db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255609db",
  null
  
)

export default component.exports